var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var HeroSlider = require('components/hero-slider');
var ProductTypePicker = require('components/product-type-picker.js');

var HomeProductsSlider = function(el) {
  this.$el = $(el);
  this.$tabs = this.$el.find('.product-type-tab');
  this.$slider = this.$el.find('.page-hero-slider');

  this.$picker = this.$el.find('.product-type-picker');
  this.picker = new ProductTypePicker(this.$picker[0]);
  
  this.slider = new HeroSlider(this.$slider[0], this.$tabs);

  // this.$el.on('slide-in.vsc-slide', function(event, data) {
  //   if(data && typeof data.index !== 'undefined') {
  //     this.picker.scrollToTab(this.$picker.find('.product-type-tab').eq(data.index));
  //   }
  // }.bind(this));

  
};

module.exports = HomeProductsSlider;